import $ from 'jquery'

$(document).on('st-in', '[data-st]', function() {
    let $products = $(this).find('.products')

    if (!$products.length) {
        return
    }

    // Wait for title transition
    setTimeout(() => {
        $products.find('.product').each((i, el) => {
            let $el = $(el)
    
            setTimeout(
                () => $el.imagesLoaded(() => {
                    $el.addClass('media-ready')
                    setTimeout(() => $el.addClass('animated'), 1000)
                }), 
                i * 500
            )
        })
    }, $(window).width() > 1200 ? 500 : 0)    
})